module.exports = __webpack_public_path__ + "4ba6387c25fbe3890245c92af5224b7d.jpg";